import fetch from "isomorphic-unfetch";

import { GenAvatarVideoRequest } from "../types";

import { caseConvertGenAvatarVideoRequest } from "../utils/requestCaseConverter";
import {
  caseConvertGenAvatar,
  caseConvertDownloadAvatarVideoResponse,
} from "../utils/responseCaseConverter";

/**
 * Call speech to text
 * @param formData
 * @param formData.avatar_name
 * @param formData.language
 * @param formData.avatar_voice
 * @param formData.avatar_img
 * @param formData.avatar_pitch
 * @param formData.avatar_speaking_rate
 * @returns
 */
export const createOrUpdateAvatar = async (formData: FormData) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_AVATARTRAINING_AI_API_DOMAIN}/avatargen/avatar`,
    {
      method: "POST",
      body: formData,
    }
  );

  return {
    data: caseConvertGenAvatar(await response.json()),
    status: response.status,
    statusText: response.statusText,
    isError: !response.ok,
  };
};

export const downloadGenAvatarVideo = async (
  avatarId: string,
  videoId: string,
  language: string
) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_AVATARTRAINING_AI_API_DOMAIN}/avatargen/avatar/${avatarId}/video/${videoId}?language=${language}`,
    {
      method: "GET",
    }
  );

  return {
    data: caseConvertDownloadAvatarVideoResponse(await response.json()),
    status: response.status,
    statusText: response.statusText,
    isError: !response.ok,
  };
};

export const generateAvatarVideo = async (request: GenAvatarVideoRequest) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_AVATARTRAINING_AI_API_DOMAIN}/avatargen/video`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(caseConvertGenAvatarVideoRequest(request)),
    }
  );

  return {
    data: response,
    status: response.status,
    statusText: response.statusText,
    isError: !response.ok,
  };
};
